let notificationId = 0

const state = {
  notifications: []
}

const mutations = {
  ADD_NOTIFICATION(state, notification) {
    state.notifications.push({
      id: ++notificationId,
      ...notification,
      timestamp: Date.now()
    })
  },
  
  REMOVE_NOTIFICATION(state, id) {
    const index = state.notifications.findIndex(n => n.id === id)
    if (index > -1) {
      state.notifications.splice(index, 1)
    }
  },
  
  CLEAR_NOTIFICATIONS(state) {
    state.notifications = []
  }
}

const actions = {
  addNotification({ commit }, notification) {
    commit('ADD_NOTIFICATION', notification)
    
    // Auto-remove après 5 secondes pour les notifications de succès et info
    if (['success', 'info'].includes(notification.type)) {
      setTimeout(() => {
        commit('REMOVE_NOTIFICATION', notificationId)
      }, 5001)
    }
    // Auto-remove après 8 secondes pour les warnings
    else if (notification.type === 'warning') {
      setTimeout(() => {
        commit('REMOVE_NOTIFICATION', notificationId)
      }, 8000)
    }
    // Les erreurs restent jusqu'à ce que l'utilisateur les ferme manuellement
  },
  
  removeNotification({ commit }, id) {
    commit('REMOVE_NOTIFICATION', id)
  },
  
  clearNotifications({ commit }) {
    commit('CLEAR_NOTIFICATIONS')
  },
  
  // Méthodes de convenance
  showSuccess({ dispatch }, message) {
    dispatch('addNotification', {
      type: 'success',
      message,
      title: 'Succès'
    })
  },
  
  showError({ dispatch }, message) {
    dispatch('addNotification', {
      type: 'error',
      message,
      title: 'Erreur'
    })
  },
  
  showWarning({ dispatch }, message) {
    dispatch('addNotification', {
      type: 'warning',
      message,
      title: 'Attention'
    })
  },
  
  showInfo({ dispatch }, message) {
    dispatch('addNotification', {
      type: 'info',
      message,
      title: 'Information'
    })
  }
}

const getters = {
  notifications: state => state.notifications,
  notificationCount: state => state.notifications.length,
  hasNotifications: state => state.notifications.length > 0
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
